import { Portal_RelativeHREF } from '../global/portal';
import type { Checkout_Step } from './checkout/CheckoutStepsProvider';

export const PORTAL_RELATIVE_HREF_WISHLIST = Portal_RelativeHREF('/wishlist');
export const PORTAL_RELATIVE_HREF_CART = Portal_RelativeHREF('/cart');
export function PORTAL_RELATIVE_HREF_CHECKOUT(step: Checkout_Step) {
    return Portal_RelativeHREF(`/checkout/${step}` as const);
}
